import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';
import { GlossaryMetadataItem } from '../pages/glossary-metadata/glossary-metadata-helper';

export const useGlossaryMetadataQueryProps = {
    enabled: true,
    retry: false,
    refetchOnWindowFocus: false,
};

const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<GlossaryMetadataItem[], any>> => {
    const headers = getDefaultHeaders(token);

    return axiosInstance().get(url, withHeaders(headers));
};

export const useGlossaryMetadataList = (
    props: any = useGlossaryMetadataQueryProps
): UseQueryResult<AxiosResponse<GlossaryMetadataItem[], any>, unknown> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const { getToken } = useAuth();
    const { queryProps } = props;

    return useQuery(
        'glossary-metadata-list',
        async () => getQueryData('/metadata/glossary', getToken()),
        {
            ...queryProps,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ??
                    'Unable to retrieve glossary metadata list';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
